/*
 * This handles checking Cortex licenses before and during calling Cortex APIs.

 * This API will eventually provide a base implementation for all apps, while it allows apps to override the
 * get/set license code for performance improvements (e.g. getting the license data from the app instead of the API).
 */
type GetLicenseHook = () => boolean | undefined;
type SetLicenseHook = (isLicensed: boolean) => void;

let getLicenseImpl: GetLicenseHook;
let setLicenseImpl: SetLicenseHook;

export function setCortexLicenseHooks(getLicense: GetLicenseHook, setLicense: SetLicenseHook) {
    getLicenseImpl = getLicense;
    setLicenseImpl = setLicense;
}

/**
 * If Cortex license is not defined, the app can call the Cortex API which verifies that the license is correctly set.
 */
export function canCallCortexApi(): boolean {
    const cortexLicense = getCortexLicense();
    if (cortexLicense === undefined) {
        return true;
    }
    return cortexLicense;
}

function getCortexLicense(): boolean | undefined {
    if (!!getLicenseImpl) {
        return getLicenseImpl();
    } else {
        return undefined;
    }
}

export function setCortexLicense(isLicensed: boolean): void {
    if (!!setLicenseImpl) {
        setLicenseImpl(isLicensed);
    }
}
